/**
 * @flow
 */
'use strict';

export const rosGeneralCodes = [
    {"code":"Normal"},
    {"code":"Weight loss"},
    {"code":"Weight gain"},
    {"code":"Fever"},
    {"code":"Chills"},
    {"code":"Insomnia"},
    {"code":"Fatigue"},
    {"code":"Weakness"}
]

export const rosEarCodes = [
    {"code":"Normal"},
    {"code":"Change in hearing"},
    {"code":"Ear pain"},
    {"code":"Ear discharge"},
    {"code":"Ringing"},
    {"code":"Dizziness"}
]

export const rosNoseCodes = [
    {"code":"Normal"},
    {"code":"Nose bleeds"},
    {"code":"Nasal stuffiness"},
    {"code":"Sinus congestion"}
]

export const rosAllergicCodes = [
    {"code":"Normal"},
    {"code":"Hives"},
    {"code":"Swelling of lips or tongue"},
    {"code":"Hay fever"},
    {"code":"Asthma"},
    {"code":"Eczema/Sensitive"},
    {"code":"Sensitivity to drugs/food/pollen/dander"}
]

export const rosMouthCodes = [
    {"code":"Normal"},
    {"code":"Dry mouth"},
    {"code":"Sore throat"},
    {"code":"Sore Tongue"},
    {"code":"Hoarseness"},
    {"code":"Mouth sores"},
    {"code":"Dentures"},
    {"code":"Bleeding gums"}
]

export const rosSkinCodes = [
    {"code":"Normal"},
    {"code":"Rashes"},
    {"code":"Itching"},
    {"code":"Change in hair or nails"}
]

export const rosHeadCodes = [
    {"code":"Normal"},
    {"code":"Headaches"},
    {"code":"Head injury"}
]

export const rosNeckCodes = [
    {"code":"Normal"},
    {"code":"Lumps"},
    {"code":"Swollen glands"},
    {"code":"Goiter"},
    {"code":"Stiffness"}
]

export const rosBreastCodes = [
    {"code":"Normal"},
    {"code":"Lumps"},
    {"code":"Nipple discharge"},
    {"code":"BSE"}
]

export const rosRespiratoryCodes =  [
    {"code":"Normal"},
    {"code":"Shortness of breath"},
    {"code":"Cough"},
    {"code":"Production of phlegm, color"},
    {"code":"Wheezing"},
    {"code":"Coughing up blood"},
    {"code":"Chest pain"},
    {"code":"Pacemaker"},
    {"code":"Fever"},
    {"code":"Night sweats"},
    {"code":"Swelling in hands/feet"},
    {"code":"Blue fingers/toes"},
    {"code":"High blood pressure"},
    {"code":"Difficulty breathing lying down (orthopnea)"},
    {"code":"HX of heart medication"},
    {"code":"High cholesterol"},
    {"code":"Heart Murmur"},
    {"code":"Skipping heart beats"},
    {"code":"Bronchitis/emphysema"},
    {"code":"Rheumatic heart disease"},
    {"code":"COPD"},
    {"code":"Hemoptysis"},
    {"code":"Lung cancer"},
    {"code":"Pneumonia"},
    {"code":"Tuberculosis"}
]

export const rosGastroCodes = [
    {"code":"Normal"},
    {"code":"Change of appetite"},
    {"code":"Change of weight"},
    {"code":"Problems swallowing"},
    {"code":"Nausea"},
    {"code":"Vomiting"},
    {"code":"Vomiting blood"},
    {"code":"Constipation"},
    {"code":"Diarrhea"},
    {"code":"Change in bowel habits"},
    {"code":"Abdominal pain"},
    {"code":"Excessive belching"},
    {"code":"Excessive flatus"},
    {"code":"Yellow color of skin (jaundice/hepatitis)"},
    {"code":"Food intolerance"},
    {"code":"Rectal bleeding/Hemorrhoids"}
]

export const rosUrinaryCodes = [
    {"code":"Normal"},
    {"code":"Difficulty in urination"},
    {"code":"Pain or burning on urination"},
    {"code":"Frequent urination at night"},
    {"code":"Urgent need to urinate"},
    {"code":"Incontinence of urine"},
    {"code":"Dribbling"},
    {"code":"Decreased urine stream"},
    {"code":"Blood in urine"},
    {"code":"UTI/stones/prostate infection"}
]

export const rosMusculosketletalCodes = [
    {"code":"Normal"},
    {"code":"Pain"},
    {"code":"Swelling"},
    {"code":"Stiffness"},
    {"code":"Decreased joint motion"},
    {"code":"Broken bone"},
    {"code":"Serious sprains"},
    {"code":"Arthtritis"},
    {"code":"Gout"}
]

export const rosNeurologicCodes = [
    {"code":"Normal"},
    {"code":"Headaches"},
    {"code":"Seizures"},
    {"code":"Loss of consciousness/Fainting"},
    {"code":"Paralysis"},
    {"code":"Weakness"},
    {"code":"Loss of muscle size"},
    {"code":"Muscle spasm"},
    {"code":"Tremor"},
    {"code":"Involuntary movement"},
    {"code":"Incoordination"},
    {"code":"Numbness"},
    {"code":"Feeling of pins and needles/tingles"}
]

export const rosEndocrineCodes = [
    {"code":"Normal"},
    {"code":"Abnormal growth"},
    {"code":"Increased appetite"},
    {"code":"Increased thirst"},
    {"code":"Increased urine production"},
    {"code":"Thyroid trouble"},
    {"code":"Heat intolerance"},
    {"code":"Cold intolerance"},
    {"code":"Excessive sweating"},
    {"code":"Diabetes"}
]

export const rosHematologicCodes = [
    {"code":"Normal"},
    {"code":"Anemia"},
    {"code":"Easy bruising/bleeding"},
    {"code":"Past transfusions"}
]

export const rosPeripheralCodes = [
    {"code":"Normal"},
    {"code":"Leg cramps"},
    {"code":"Varicose veins"},
    {"code":"Clots in veins"}
]

export const rosPshychiatricCodes = [
    {"code":"Normal"},
    {"code":"Tension/Anxiety"},
    {"code":"Depression"},
    {"code":"Suicide ideation"},
    {"code":"Memory problems"},
    {"code":"Sleep problems"},
    {"code":"Past treatment with psychiatrist"}
]
